export default __webpack_public_path__ + "static/media/CarImages.SportagSmall.1319ede0.jpg";